import { Grid } from "@mui/material";
import React from "react";
import Features from "./Features";

function ImageAndFeatures() {
  return (
    <Grid container direction="row" spacing={1}>
      <Grid item>
        <img
          style={{ border: "2px solid grey" }}
          src="../PBHImage.jpg"
          alt="Primitive Baptist Hymnal"
          width="300px"
          height="268px"
        />
      </Grid>
      <Grid item>
        <Features />
      </Grid>
    </Grid>
  );
}

export default ImageAndFeatures;
